"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsTableSchema = void 0;
exports.ResultsTableSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/results-table.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ResultsTable",
    "description": "A table that allows to display information about results using typed columns",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "title": {
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        "type": {
            "type": "string",
            "enum": [
                "attributes:results-table"
            ]
        },
        "columns": {
            "type": "array",
            "uniqueItems": true,
            "minItems": 3,
            "allOf": [
                {
                    "contains": {
                        "type": "object",
                        "properties": {
                            "name": {
                                "const": "rank"
                            },
                            "pinned": {
                                "type": "boolean",
                                "default": false
                            },
                            "title": {
                                "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                            }
                        },
                        "required": [
                            "name",
                            "pinned",
                            "title"
                        ]
                    }
                },
                {
                    "contains": {
                        "type": "object",
                        "properties": {
                            "name": {
                                "const": "person"
                            },
                            "pinned": {
                                "type": "boolean",
                                "default": false
                            },
                            "title": {
                                "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                            }
                        },
                        "required": [
                            "name",
                            "pinned",
                            "title"
                        ]
                    }
                },
                {
                    "contains": {
                        "type": "object",
                        "properties": {
                            "name": {
                                "const": "mainResult"
                            },
                            "pinned": {
                                "type": "boolean",
                                "default": false
                            },
                            "title": {
                                "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                            },
                            "formatHint": {
                                "type": "string",
                                "description": "The formatHint allows to specify a unit to add context to the result.",
                                "enum": [
                                    "integer",
                                    "float",
                                    "percent",
                                    "points",
                                    "timestamp",
                                    "text"
                                ]
                            }
                        },
                        "required": [
                            "name",
                            "pinned",
                            "title"
                        ]
                    }
                }
            ],
            "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "pinned": {
                        "type": "boolean",
                        "default": false
                    },
                    "title": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    },
                    "formatHint": {
                        "type": "string",
                        "description": "The formatHint allows to specify a unit to add context to the result.",
                        "enum": [
                            "integer",
                            "float",
                            "percent",
                            "points",
                            "timestamp",
                            "text"
                        ]
                    }
                },
                "required": [
                    "name",
                    "pinned",
                    "title"
                ]
            }
        },
        "rows": {
            "type": "array",
            "items": {
                "type": "object",
                "properties": {
                    "mainResult": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    },
                    "person": {
                        "anyOf": [
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
                            }
                        ]
                    },
                    "rank": {
                        "type": "object",
                        "allOf": [
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                            }
                        ],
                        "properties": {
                            "text": {
                                "type": "string",
                                "maxLength": 3
                            }
                        }
                    }
                },
                "required": [
                    "mainResult",
                    "person",
                    "rank"
                ],
                "patternProperties": {
                    "^[a-z][a-zA-Z]+[0-9]*$": {
                        "type": [
                            "object"
                        ],
                        "anyOf": [
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
                            }
                        ]
                    }
                }
            }
        }
    },
    "required": [
        "columns",
        "rows",
        "title",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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